/**
 * WDropDownMenu — polskie tłumaczenia (mega-menu).
 *
 * Funkcja `submenuToggleLabel(name, open)` buduje aria-label dla chevron'a
 * z nazwą sekcji + stanem (zwiń/rozwiń) — wymaga substitucji więc nie może
 * być statycznym stringiem.
 *
 * Funkcja `currentLanguageAria` używana w analogicznym miejscu w innych
 * komponentach — tutaj zachowane dla spójności wzorca, nie jest tu używane.
 */
import type { DeepString } from "@/lib/i18n";

export const pl = {
  ariaLabelFallback: "Menu",
  empty: "Brak pozycji w menu.",
  seeAll: "zobacz wszystko",
  submenuExpand: "Rozwiń",
  submenuCollapse: "Zwiń",
  /** Aria-label dla chevron toggle'a — `name` = nazwa sekcji menu. */
  submenuToggleLabel: (name: string, open: boolean) =>
    `${open ? "Zwiń" : "Rozwiń"} podmenu: ${name}`,
  devBanner: {
    /** Prefix "DEV-only:" przed treścią banneru. */
    prefix: "DEV-only:",
    body:
      "przykładowe drzewo z zagnieżdżeniem do poziomu 5. Widoczne tylko w środowisku dev — toggle w pasku admin (ikona",
    iconLabel: "list-bullets",
    suffix: ") wyłącza wstrzykiwanie tego wpisu.",
    mockL1Name: "DEV: Pełne drzewo",
  },
} as const;

export type WDropDownMenuTranslations = DeepString<typeof pl>;
